import React, { useEffect, useState } from "react";
import {
  getFirestore,
  doc,
  updateDoc,
  onSnapshot,
  deleteField,
} from "firebase/firestore";

const DeleteEvolution = ({ selectedPatient, onClose }) => {
  const [evolutions, setEvolutions] = useState({});
  const [selectedEvolution, setSelectedEvolution] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedEvolutionText, setSelectedEvolutionText] = useState("");

  useEffect(() => {
    if (!selectedPatient) return;

    const db = getFirestore();
    const patientRef = doc(db, "registeredPatients", selectedPatient.id);

    const unsubscribe = onSnapshot(
      patientRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setEvolutions(data.evolutions || {});
        }
      },
      () => {
        setError("Ocurrió un error al cargar las evoluciones.");
      }
    );

    return () => unsubscribe();
  }, [selectedPatient]);

  const handleDelete = async () => {
    if (!selectedEvolution) {
      setError("Por favor, elige una evolución para eliminar.");
      return;
    }

    try {
      const db = getFirestore();
      const patientRef = doc(db, "registeredPatients", selectedPatient.id);

      const updatedEvolutions = { ...evolutions };
      delete updatedEvolutions[selectedEvolution];

      const updateData =
        Object.keys(updatedEvolutions).length > 0
          ? { evolutions: updatedEvolutions }
          : { evolutions: deleteField() };

      await updateDoc(patientRef, updateData);

      setSuccess("La evolución se eliminó correctamente.");
      setError("");
      setSelectedEvolution("");
      setConfirmDelete(false);
    } catch (error) {
      setError("Ocurrió un error al eliminar la evolución.");
    }
  };

  const handleSelectEvolution = (e) => {
    const selectedKey = e.target.value;
    setSelectedEvolution(selectedKey);

    if (selectedKey && evolutions[selectedKey]) {
      const fullText = evolutions[selectedKey].observation;
      const shortText =
        fullText.length > 30 ? fullText.substring(0, 30) + "..." : fullText;
      setSelectedEvolutionText(shortText);
    } else {
      setSelectedEvolutionText("");
    }
  };

  return (
    <div>
      <h2>Eliminar Evolución</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      {!confirmDelete ? (
        <>
          <select
            value={selectedEvolution}
            onChange={handleSelectEvolution}
            className="generalFormInput"
            style={{
              width: "100%",
              marginBottom: "10px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <option value="">Selecciona una evolución</option>
            {Object.entries(evolutions).map(([key, evolution]) => (
              <option
                key={key}
                value={key}
                title={`${evolution.observation} | ${evolution.date}`}
              >
                {`${evolution.observation} | ${evolution.date}`.length > 50
                  ? `${evolution.observation.substring(0, 25)}... | ${
                      evolution.date
                    }`
                  : `${evolution.observation} | ${evolution.date}`}
              </option>
            ))}
          </select>
          <button
            onClick={() => setConfirmDelete(true)}
            disabled={!selectedEvolution}
          >
            Eliminar
          </button>
        </>
      ) : (
        <div className="confirmationBox">
          <p>
            ¿Confirmas que deseas eliminar la evolución "{selectedEvolutionText}
            "?
          </p>
          <button onClick={handleDelete} className="confirmButton">
            Sí
          </button>
          <button
            onClick={() => setConfirmDelete(false)}
            className="cancelButton"
          >
            No
          </button>
        </div>
      )}
    </div>
  );
};

export default DeleteEvolution;
